import kanemaInstance from "../../../services/kanemaInstance";
import katswiriInstance from "../../../services/katswiriInstance";
import mingoliInstance from "../../../services/mingoliInstance";

export const getKanemaUsers = async (skip = 0, limit = 10) => {
    try {
        const response = await kanemaInstance.get('/users', {
            params: {
                skip,
                limit
            }
        });
        return response.data.message;
    } catch (error) {
        throw error;
    }
};

export const getAllKanemaUsers = async () => {
    try {
        const allUsers: any[] = [];
        let skip = 0;
        const limit = 500;
        let hasMore = true;
        let totalFetched = 0;

        while (hasMore) {
            const response = await getKanemaUsers(skip, limit);

            if (!Array.isArray(response)) {
                throw new Error('Invalid response format from server');
            }

            if (response.length === 0 || response.length < limit) {
                hasMore = false;
                console.log('No more users to fetch');
            } else {
                allUsers.push(...response);
                totalFetched += response.length;
                skip += limit;
            }
        }

        return allUsers;
    } catch (error) {
        throw error;
    }
};

export const getKatswiriUsers = async (skip = 0, limit = 10) => {
    try {
        const response = await katswiriInstance.get('/users', {
            params: {
                skip,
                limit
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllKatswiriUsers = async () => {
    try {
        const allUsers: any[] = [];
        let skip = 0;
        const limit = 100;
        let hasMore = true;

        while (hasMore) {
            const response = await getKatswiriUsers(skip, limit);

            // response.message holds the array
            const users = response.message;

            if (!users || users.length === 0) {
                hasMore = false;
            } else {
                allUsers.push(...users);
                skip += limit;
            }
        }

        return allUsers;
    } catch (error) {
        throw error;
    }
};



export const getMingoliUsers = async () => {
    try {
        const response = await mingoliInstance.get('/users');
        return response.data.users;
    } catch (error) {
        throw error;
    }
};